export default __webpack_public_path__ + "static/media/Batman_00.258f1f85.png";